
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!assignments.assignment_list_item_score";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'assignments/-assignmentListItemScore';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.submission), ((stack1 = (depth0 && depth0.submission)),stack1 == null || stack1 === false ? stack1 : stack1.excused), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.submission), ((stack1 = (depth0 && depth0.submission)),stack1 == null || stack1 === false ? stack1 : stack1.excused), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "excused_cf8792eb", "Excused", options) : helperMissing.call(depth0, "t", "excused_cf8792eb", "Excused", options)))
    + "\n    ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.program(14, program14, data),fn:self.program(5, program5, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.submission), ((stack1 = (depth0 && depth0.submission)),stack1 == null || stack1 === false ? stack1 : stack1.submitted_or_graded), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.submission), ((stack1 = (depth0 && depth0.submission)),stack1 == null || stack1 === false ? stack1 : stack1.submitted_or_graded), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n\n        ";
  stack1 = helpers['with'].call(depth0, (depth0 && depth0.submission), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n      ";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.notYetGraded), {hash:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n\n            <span class=\"score-display\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'pointsPossible': ((depth0 && depth0.pointsPossible)),
    'scope': ("assignments.assignment_list_item_score")
  },data:data},helper ? helper.call(depth0, "empty_points_possible", "-/%{pointsPossible} pts", options) : helperMissing.call(depth0, "t", "empty_points_possible", "-/%{pointsPossible} pts", options)))
    + "\n            </span>\n            &nbsp;&#124;&nbsp;\n            <span class=\"grade-display\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "not_yet_graded_40475341", "Not Yet Graded", options) : helperMissing.call(depth0, "t", "not_yet_graded_40475341", "Not Yet Graded", options)))
    + "\n            </span>\n\n          ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <span class=\"score-display\">\n                "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'score': ((depth0 && depth0.score)),
    'pointsPossible': ((depth0 && depth0.pointsPossible)),
    'w0': ("<b>$1</b>"),
    'scope': ("assignments.assignment_list_item_score")
  },data:data},helper ? helper.call(depth0, "score_with_points_possible", "*%{score}*/%{pointsPossible} pts", options) : helperMissing.call(depth0, "t", "score_with_points_possible", "*%{score}*/%{pointsPossible} pts", options)))
    + "\n            </span>\n            ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.gradeDisplay), (depth0 && depth0.pointsPossible), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.gradeDisplay), (depth0 && depth0.pointsPossible), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.gradeDisplay), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n          ";
  return buffer;
  }
function program10(depth0,data) {
  
  
  return "\n              &nbsp;&#124;&nbsp;\n            ";
  }

function program12(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n              <span class=\"grade-display\">\n                <strong>\n                  ";
  if (helper = helpers.gradeDisplay) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.gradeDisplay); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n                </strong>\n              </span>\n            ";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n\n        <span data-tooltip=\"\" class=\"score-display\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.assignment_list_item_score")
  },data:data},helper ? helper.call(depth0, "no_submission", "No Submission", options) : helperMissing.call(depth0, "t", "no_submission", "No Submission", options)))
    + "'>\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'pointsPossible': ((depth0 && depth0.pointsPossible)),
    'scope': ("assignments.assignment_list_item_score")
  },data:data},helper ? helper.call(depth0, "empty_points_possible", "-/%{pointsPossible} pts", options) : helperMissing.call(depth0, "t", "empty_points_possible", "-/%{pointsPossible} pts", options)))
    + "\n        </span>\n\n      ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.assignment_list_item_score")
  },data:data},helper ? helper.call(depth0, "assignment_grading_type_is_not_graded", "This assignment will not be assigned a grade.", options) : helperMissing.call(depth0, "t", "assignment_grading_type_is_not_graded", "This assignment will not be assigned a grade.", options)))
    + "\n  ";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.program(21, program21, data),fn:self.program(19, program19, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.submission), ((stack1 = (depth0 && depth0.submission)),stack1 == null || stack1 === false ? stack1 : stack1.excused), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.submission), ((stack1 = (depth0 && depth0.submission)),stack1 == null || stack1 === false ? stack1 : stack1.excused), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program19(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "this_assignment_has_been_excused_87f1dc13", "This assignment has been excused.", options) : helperMissing.call(depth0, "t", "this_assignment_has_been_excused_87f1dc13", "This assignment has been excused.", options)))
    + "\n    ";
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.program(28, program28, data),fn:self.program(22, program22, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.submission), ((stack1 = (depth0 && depth0.submission)),stack1 == null || stack1 === false ? stack1 : stack1.submitted_or_graded), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.submission), ((stack1 = (depth0 && depth0.submission)),stack1 == null || stack1 === false ? stack1 : stack1.submitted_or_graded), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  return buffer;
  }
function program22(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n\n        ";
  stack1 = helpers['with'].call(depth0, (depth0 && depth0.submission), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n      ";
  return buffer;
  }
function program23(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.notYetGraded), {hash:{},inverse:self.program(26, program26, data),fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n        ";
  return buffer;
  }
function program24(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'pointsPossible': ((depth0 && depth0.pointsPossible)),
    'scope': ("assignments.assignment_list_item_score")
  },data:data},helper ? helper.call(depth0, "assignment_not_yet_graded_screenreader", "Assignment not yet graded. %{pointsPossible} points possible.", options) : helperMissing.call(depth0, "t", "assignment_not_yet_graded_screenreader", "Assignment not yet graded. %{pointsPossible} points possible.", options)))
    + "\n\n          ";
  return buffer;
  }

function program26(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'score': ((depth0 && depth0.score)),
    'pointsPossible': ((depth0 && depth0.pointsPossible)),
    'scope': ("assignments.assignment_list_item_score")
  },data:data},helper ? helper.call(depth0, "score_with_points_possible_screenreader", "Score: %{score} out of %{pointsPossible} points.", options) : helperMissing.call(depth0, "t", "score_with_points_possible_screenreader", "Score: %{score} out of %{pointsPossible} points.", options)))
    + "\n            ";
  if (helper = helpers.gradeDisplayForScreenreader) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.gradeDisplayForScreenreader); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n\n          ";
  return buffer;
  }

function program28(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'pointsPossible': ((depth0 && depth0.pointsPossible)),
    'scope': ("assignments.assignment_list_item_score")
  },data:data},helper ? helper.call(depth0, "no_submission_for_assignment_screenreader", "No submission for this assignment. %{pointsPossible} points possible.", options) : helperMissing.call(depth0, "t", "no_submission_for_assignment_screenreader", "No submission for this assignment. %{pointsPossible} points possible.", options)))
    + "\n\n      ";
  return buffer;
  }

  buffer += "<span class=\"non-screenreader\" aria-hidden=\"true\">\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideGrade), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</span>\n\n<span class=\"screenreader-only\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hideGrade), {hash:{},inverse:self.program(18, program18, data),fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n</span>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('assignments/assignmentListItemScore', templates['assignments/-assignmentListItemScore']);
    ;
    ;
    export default templates[name];
  